import { useTranslation } from 'react-i18next';
import AttrLabel from '../Components/AttrLabel';
import AttrField from './AttrField';
import ColorField from './ColorField';
import PixelField from './PixelField';
import SelectField from './SelectField';

const BorderFields = ({ property, disableRaduis }) => {
    const { t } = useTranslation();

    return (
        <>
            {!disableRaduis && (
                <>
                    <AttrLabel>{t('Rounded Corners')}</AttrLabel>
                    <AttrField
                        Component={PixelField}
                        name="borderRadius"
                        placeholder={t('Rounded Corners')}
                        property={property}
                    />
                </>
            )}
            <AttrLabel>{t('Border Style')}</AttrLabel>
            <AttrField
                Component={SelectField}
                name="borderStyle"
                options={[
                    { label: <em>{t('None')}</em>, value: 'none' },
                    { label: t('Solid'), value: 'solid' },
                    { label: t('Dotted'), value: 'dotted' },
                    { label: t('Dashed'), value: 'dashed' },
                    { label: t('Double'), value: 'double' },
                    { label: t('Groove'), value: 'groove' },
                    { label: t('Ridge'), value: 'ridge' },
                    { label: t('Inset'), value: 'inset' },
                    { label: t('Outset'), value: 'outset' },
                ]}
                renderOptionStyle={option => ({
                    '&::after': {
                        content: '""',
                        display: 'inline-block',
                        ml: 'auto',
                        width: 64,
                        height: '1em',
                        border: `4px ${option.value} #006495`,
                        borderRadius: 1,
                    },
                })}
                property={property}
            />
            <AttrLabel>{t('Border Width')}</AttrLabel>
            <AttrField
                Component={PixelField}
                name="borderWidth"
                placeholder={t('Border Width')}
                property={property}
            />
            <AttrLabel>{t('Border Color')}</AttrLabel>
            <AttrField
                Component={ColorField}
                name="borderColor"
                placeholder={t('Border Color')}
                property={property}
            />
        </>
    );
};
export default BorderFields;
